export const SET_CONTACT_INFO = 'SET_CONTACT';
export const SET_TRADE = 'SET_TRADE';
export const SET_OFFER_ID = 'SET_OFFER_ID';
export const RESET_NEW_BUY = 'RESET_NEW_BUY';
